var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8031_424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9432 3.62061H14.6758V11.6106H38.0582V7.73402C38.0582 5.46567 36.2122 3.62061 33.9432 3.62061Z",
    fill: "#CED9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0352 12.8403H0.5V5.42636C0.5 2.70972 2.71068 0.5 5.42828 0.5H12.6336C13.3497 0.5 14.0396 0.650925 14.6664 0.934509C15.5418 1.32896 16.2939 1.97913 16.8213 2.8286L23.0352 12.8403Z",
    fill: "#1640C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 14.4999V38.3812C42.5 40.6525 40.6511 42.4998 38.3789 42.4998H4.62111C2.34891 42.4998 0.5 40.6525 0.5 38.3812V10.3804H38.3789C40.6511 10.3804 42.5 12.2283 42.5 14.4999Z",
    fill: "#2354E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 14.4999V38.3812C42.5 40.6525 40.6511 42.4998 38.3789 42.4998H21.5V10.3804H38.3789C40.6511 10.3804 42.5 12.2283 42.5 14.4999Z",
    fill: "#1849D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.549 26.44C32.549 32.5325 27.5928 37.4889 21.5011 37.4889C15.4093 37.4889 10.4531 32.5325 10.4531 26.44C10.4531 20.3486 15.4093 15.3921 21.5011 15.3921C27.5928 15.3921 32.549 20.3486 32.549 26.44Z",
    fill: "#E7ECFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5479 26.44C32.5479 32.5325 27.5918 37.4889 21.5 37.4889V15.3921C27.5918 15.3921 32.5479 20.3486 32.5479 26.44Z",
    fill: "#CED9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0593 26.5753C24.8289 26.7704 24.5466 26.8656 24.2668 26.8656C23.9166 26.8656 23.5686 26.7173 23.3251 26.4282L22.7287 25.7213V30.3494C22.7287 31.0287 22.1776 31.5799 21.4983 31.5799C20.8189 31.5799 20.2678 31.0287 20.2678 30.3494V25.7213L19.6715 26.4282C19.2325 26.9476 18.4567 27.014 17.9373 26.5753C17.4182 26.1373 17.3515 25.3612 17.7896 24.8418L20.2252 21.9543C20.5427 21.5788 21.0061 21.3628 21.4983 21.3628C21.9905 21.3628 22.4538 21.5788 22.7714 21.9543L25.207 24.8418C25.645 25.3612 25.5784 26.1373 25.0593 26.5753Z",
    fill: "#6C8DEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.061 26.5753C24.8306 26.7704 24.5483 26.8656 24.2686 26.8656C23.9183 26.8656 23.5703 26.7173 23.3268 26.4282L22.7305 25.7213V30.3494C22.7305 31.0287 22.1793 31.5799 21.5 31.5799V21.3628C21.9922 21.3628 22.4555 21.5788 22.7731 21.9543L25.2087 24.8418C25.6467 25.3612 25.5801 26.1373 25.061 26.5753Z",
    fill: "#3B67E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8031_424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.59ae72fb7e52b653716044082c434bc8.svg";
export { ForwardRef as ReactComponent };